export const sanitizeQueryParams = (value) => {
  if (typeof value === "string") {
    // Check if the string contains commas
    if (value.includes(",")) {
      return value
        .split(",") // Split by commas
        .map(item => item.trim()) // Trim each part
        .join(","); // Join back with commas
    } else {
      return value.trim(); // Trim the entire string if no commas
    }
  }
  return value; // Return as is if not a string
}